import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import HomePage from './components/HomePage';
import BookingPage from './components/BookingPage';
import ProfilePage from './components/ProfilePage';
import ServiceDetailPage from './components/ServiceDetailPage';
import PaymentPage from './components/PaymentPage';
import PaymentSuccess from './components/PaymentSuccess';
import JoinPage from './components/JoinPage';
import MyPage from './components/MyPage';
import CustomerServicePage from './components/CustomerServicePage';
import MembershipPackage from './components/MembershipPackage';
import MemberRightsPage from './components/MemberRightsPage';
import BottomNav from './components/BottomNav';
import { getUrlParameter } from './utils/urlUtils';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [userInfo, setUserInfo] = useState(null);
  const location = useLocation();

  // 定义需要显示底部导航栏的页面路径
  const showNavPaths = ['/', '/join', '/customer-service', '/my'];
  const shouldShowNav = showNavPaths.includes(location.pathname);

  useEffect(() => {
    const initializeApp = async () => {
      try {
        // 获取当前路径和URL参数
        const currentPath = window.location.pathname;
        const actNo = getUrlParameter('act_no');

        // 识别广告来源
        let adSource = 'direct';
        if (currentPath.includes('/tuia')) {
          adSource = 'tuia';
        } else if (currentPath.includes('/bxm')) {
          adSource = 'bxm';
        }

  // 初始化广告追踪（已移除 adTracker 实现）
  // adSource and actNo are still available here if you want to send them to another analytics service

        // 初始化用户信息
        const userInfoFromStorage = localStorage.getItem('housekeeping_user_info');
        if (userInfoFromStorage) {
          setUserInfo(JSON.parse(userInfoFromStorage));
        }

        setIsLoading(false);
      } catch (error) {
        console.error('应用初始化失败:', error);
        setIsLoading(false);
      }
    };

    initializeApp();
  }, []);

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        backgroundColor: '#f5f7fa'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            width: '40px', 
            height: '40px', 
            border: '3px solid #e3f2fd',
            borderTop: '3px solid #2196f3',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 10px'
          }} />
          <p style={{ color: '#666', fontSize: '14px' }}>加载中...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`App ${shouldShowNav ? 'has-bottom-nav' : 'no-bottom-nav'}`}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/detail" element={<ServiceDetailPage />} />
        <Route path="/payment" element={<PaymentPage />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/join" element={<JoinPage />} />
        <Route path="/customer-service" element={<CustomerServicePage />} />
        <Route path="/membership-package" element={<MembershipPackage />} />
        <Route path="/member-rights" element={<MemberRightsPage />} />
        <Route path="/my" element={<MyPage />} />
      </Routes>
      <BottomNav />
    </div>
  );
}

export default App;
